const {  REACT_APP_BASE_URL  } = process.env;


export default {
    async createPost(postData) {
        let data = await fetch(`${ REACT_APP_BASE_URL }/posts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
        })
        return await data.json()
    },
    async getAllPosts() {
        let response = await fetch(`${ REACT_APP_BASE_URL }/posts`)
        return await response.json()
    },
    async getPostById(postId) {
        let response = await fetch(`${ REACT_APP_BASE_URL }/posts/${postId}`)
        return await response.json()
    },
    async createComment(postId, postComment) {
        let response = await fetch(`${ REACT_APP_BASE_URL }/posts/${postId}/comment`, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postComment)
        })
        return await response.json()
    },
    async updateReactionByPostId(postId, authorId) {
        let postById = await this.getPostById(postId)
        let {reactions, reactions_count} = postById.data.post;
        let reaction =  {
            $set: {
                reactions: [authorId ]
            },
            reactions_count: 1
        }
        if( reactions  )
        {
            
            let reactionIndex = reactions.indexOf(authorId)

            if (reactionIndex === -1) {
                reaction = {
                    $push: {
                        reactions: [...reactions, authorId ]
                    },
                    reactions_count: ++reactions_count
                }

            } else {

                reaction = {
                    $unset: {
                        reactions: [authorId ]
                    },
                    reactions_count: --reactions_count
                }
            }

        } 
        console.log(reaction)
        let response = await fetch(`${ REACT_APP_BASE_URL }/posts/${postId}`, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reaction)
        })
        return await response.json()
    },
    async login(userData){
        let data = await fetch(`${ REACT_APP_BASE_URL }/auth/login`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        })
        return await data.json()
    },
    async signin(userData){
        let data = await fetch(`${ REACT_APP_BASE_URL }/users`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        })
        return await data.json()
    },
    parseJwt (token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(jsonPayload);
	}
}